import { util } from 'echarts/core';
import { type ThemeParser } from '../../../core/theme';
import { overrideIfUndefined } from '../../../util/data';
import { fontColor, FONT_LEVEL_LIST } from '../static/font';

const DEFAULT_ITEM_WIDTH = 12;
const DEFAULT_ITEM_HEIGHT = 12;

function parseLegendSize(option: Parameters<ThemeParser>[0]) {
  const { legend } = option;
  if (legend) {
    legend.itemWidth = overrideIfUndefined(option.legend.itemWidth, DEFAULT_ITEM_WIDTH);
    legend.itemHeight = overrideIfUndefined(option.legend.itemHeight, DEFAULT_ITEM_HEIGHT);
  }
}

function parseLegendFontColor(option: Parameters<ThemeParser>[0], colorMode?: 'light' | 'dark') {
  const { legend } = option;
  if (legend) {
    legend.textStyle = util.merge(legend.itemStyle || {}, {
      color: fontColor(FONT_LEVEL_LIST.LEVEL2, colorMode)
    });
  }
}

export function legendThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  parseLegendSize(option);
  parseLegendFontColor(option, themeMode);
}
